import React from "react";
import TopSection from "./TopSection";
import MidSection from "./MidSection";
import BottomSection from "./BottomSection";

export default function QuotePageLayout() {
  return (
    <div>
      <TopSection />
      <MidSection />
      <BottomSection />
    </div>
  );
}
